<template>
    <v-card light class="main">
        <v-card-title>Добавить ссылку</v-card-title>
        <v-card-text>
            <v-container>
                <v-row justify="center">
                    <image-uploader
                            v-model="link.icon"
                            width="100"
                            height="100"
                    ></image-uploader>
                </v-row>
            </v-container>
            <v-text-field label="Иконка" v-model="link.icon"></v-text-field>

            <v-text-field label="Название" v-model="link.name"></v-text-field>
            <v-text-field label="URL" v-model="link.url"></v-text-field>
        </v-card-text>
        <v-card-actions>
            <div class="flex-md-grow-1"></div>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="cancel"
            >
                Отмена
            </v-btn>
            <v-btn
                    color="#8a2be2"
                    text
                    @click="submit"
            >
                Сохранить
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import ImageUploader from "./ImageUploader";

    export default {
        components: {ImageUploader},
        props:['links'],
        componetns:{
            ImageUploader
        },
        name: "LinkAdder",
        data: () => ({
            link: {
                icon: "",
                name: "",
                url: ""
            }
        }),
        methods:{
            submit(){
                //this.links.push(this.link)
                //this.$emit("close-adder")
                this.$emit('create-link', this.link)
                this.$emit("close-adder")
            },
            cancel(){
                this.$emit("close-adder")
            }
        }
    }
</script>

<style scoped>

</style>